<div class="action-buttons" *ngIf="!isZCDetails">
    <app-zoning-code-version-calculate-button [zoningCode]="detailsData.zoningCode"
        [zoningCodeVersion]="detailsData.zoningCodeVersion">
    </app-zoning-code-version-calculate-button>

    <app-zoning-code-version-recalculate-button [zoningCode]="detailsData.zoningCode"
        [zoningCodeVersion]="detailsData.zoningCodeVersion">
    </app-zoning-code-version-recalculate-button>

    <app-zoning-code-version-check-status-button [zoningCode]="detailsData.zoningCode"
        [zoningCodeVersion]="detailsData.zoningCodeVersion" [openDialog]="false" [(isLoaded)]="isLoaded"
        [isOpen]="true">
    </app-zoning-code-version-check-status-button>

    <app-zoning-code-version-delete-button [zoningCode]="detailsData.zoningCode"
        [zoningCodeVersion]="detailsData.zoningCodeVersion">
    </app-zoning-code-version-delete-button>
</div>

<mat-divider></mat-divider>

<div class="action-buttons" *ngIf="isZCDetails">
    <app-zoning-code-check-version-button [zoningCode]="detailsData.zoningCode">
    </app-zoning-code-check-version-button>

    <app-zoning-code-index-button [zoningCode]="detailsData.zoningCode">
    </app-zoning-code-index-button>

    <app-zoning-code-reindex-button [zoningCode]="detailsData.zoningCode">
    </app-zoning-code-reindex-button>

    <app-zoning-code-check-status-button [zoningCode]="detailsData.zoningCode" [(isLoaded)]="isLoaded"
        [openDialog]="false" [isOpen]="true">
    </app-zoning-code-check-status-button>

    <app-zoning-code-delete-button [zoningCode]="detailsData.zoningCode">
    </app-zoning-code-delete-button>
</div>

<mat-divider></mat-divider>


<div class="task-status" *ngIf="zoningCodeVersionOrZoningCode.taskOrStatistic">
    <app-task-view [task]="zoningCodeVersionOrZoningCode.taskOrStatistic"
        *ngIf="!detailsData.zoningCodeVersion?.isDeleting; else removingInProgress" [showTaskTabButton]="true">
    </app-task-view>

    <ng-template #removingInProgress>
        Removing in progress
    </ng-template>

    <mat-divider
        *ngIf="zoningCodeVersionOrZoningCode.taskOrStatistic?.canStart || zoningCodeVersionOrZoningCode.taskOrStatistic?.canStop">
    </mat-divider>

</div>


<div class="task-statistic" *ngIf="isLoaded; else spinner">
    <app-zc-indexing-process-details-view [task]="zoningCodeVersionOrZoningCode.taskOrStatistic"
        *ngIf="!detailsData.detailsEntity && hasTasks">
    </app-zc-indexing-process-details-view>

    <app-zc-details-view [zoningCode]="zoningCodeVersionOrZoningCode" *ngIf="!detailsData.detailsEntity && !hasTasks">
    </app-zc-details-view>

    <app-zcv-calc-process-details-view [task]="zoningCodeVersionOrZoningCode.taskOrStatistic"
        *ngIf="detailsData.detailsEntity && hasTasks" [hidePRThreadsList]="true">
    </app-zcv-calc-process-details-view>

    <app-zc-version-details-view [zoningCodeVersion]="zoningCodeVersionOrZoningCode"
        [zcVersionStatistic]="zoningCodeVersionOrZoningCode.taskOrStatistic" [stateEnv]="stateEnv"
        *ngIf="detailsData.detailsEntity && !hasTasks">
    </app-zc-version-details-view>
</div>

<ng-template #spinner>
    <app-spinner class="spinner"></app-spinner>
</ng-template>